import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Home = () => import("./components/home");
const Commitment = () => import("./components/commitment");
const Development = () => import("./components/development");
const Policy = () => import("./components/quality/policy");
const Cooperative = () => import("./components/cooperative");
const Technology = () => import("./components/technology");
const TechnologySensing = () => import("./components/technology-sensing");

const Category = () => import("./components/category");

const Contact = () => import("./components/contact");
const Page404 = () => import("./components/404.vue")

export default new Router({
  routes: [{
      path: "/",
      name: "home",
      components: {
        default: Home
      }
    },
    {
      path: "/commitment",
      name: "commitment",
      components: {
        default: Commitment
      }
    },
    {
      path: "/development",
      name: "development",
      components: {
        default: Development
      }
    },
    {
      path: "/quality",
      name: "quality",
      components: {
        default: Policy
      }
    },
    {
      path: "/cooperative",
      name: "cooperative",
      components: {
        default: Cooperative
      }
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        default: Contact
      }
    },
    {
      path: "/technology/sensing",
      name: "technology-sensing",
      components: {
        default: TechnologySensing
      }
    },
    {
      path: "/technology/:sub",
      name: "technology",
      components: {
        default: Technology
      }
    },
    {
      path: "/category/:sub",
      name: "category",
      components: {
        default: Category
      }
    },
    {
      path: "*",
      name: "404",
      components: {
        default: Page404
      }
    }
  ]
})